import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { observer } from 'mobx-react-lite';
import globalSettingsBranches from '../../../../../../../stores/global-settings-branches';
import { SettingsBranches } from '../../../../../../../api/types/settings/branches/settings-branches';

interface SwitchBranchDialogProps {
  visible: boolean;
  onHide: () => void;
  currentBranchId: number | null;
  onConfirm: (branchId: number) => Promise<void>;
  loading: boolean;
}

export const SwitchBranchDialog: React.FC<SwitchBranchDialogProps> = observer(
  ({ visible, onHide, currentBranchId, onConfirm, loading }) => {
    const [selectedBranchId, setSelectedBranchId] = useState<number | null>(
      null,
    );

    // Reset selection to the current branch every time the dialog opens.
    useEffect(() => {
      if (visible) {
        setSelectedBranchId(currentBranchId);
      }
    }, [visible, currentBranchId]);

    const handleConfirm = async () => {
      if (selectedBranchId === null) return;
      await onConfirm(selectedBranchId);
    };

    const canConfirm = selectedBranchId !== null && !loading;

    const branchOptions = globalSettingsBranches.branches;

    const currentBranchName =
      branchOptions.find((b) => b.id === currentBranchId)?.branchName ?? null;

    return (
      <Dialog
        header="שינוי שלוחה"
        visible={visible}
        onHide={onHide}
        style={{ width: '480px', maxWidth: '95vw' }}
        footer={
          <div
            style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}
          >
            <Button
              label="ביטול"
              icon="pi pi-times"
              severity="secondary"
              onClick={onHide}
              disabled={loading}
            />
            <Button
              label="עדכן שלוחה"
              icon="pi pi-check"
              onClick={handleConfirm}
              loading={loading}
              disabled={!canConfirm}
            />
          </div>
        }
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            direction: 'rtl',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              padding: '16px',
              backgroundColor: '#EEF2FF',
              borderRadius: '8px',
              border: '1px solid #C7D2FE',
            }}
          >
            <i
              className="pi pi-building"
              style={{ fontSize: '24px', color: '#6366F1' }}
            />
            <div>
              <div style={{ fontWeight: 'bold', color: '#4338CA' }}>
                שינוי שלוחה להוראת קבע
              </div>
              <div
                style={{
                  color: '#6366F1',
                  marginTop: '4px',
                  fontSize: '14px',
                }}
              >
                {currentBranchName
                  ? `שלוחה נוכחית: ${currentBranchName}`
                  : 'לא הוגדרה שלוחה לתוכנית זו'}
              </div>
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <label
              htmlFor="switch-branch-dropdown"
              style={{ fontSize: '14px', color: '#374151' }}
            >
              בחירת שלוחה חדשה
            </label>
            <Dropdown
              id="switch-branch-dropdown"
              value={selectedBranchId}
              options={branchOptions}
              optionLabel="branchName"
              optionValue="id"
              onChange={(e) => setSelectedBranchId(e.value ?? null)}
              placeholder="בחר שלוחה"
              filter
              filterBy="branchName"
              emptyMessage="לא נמצאו שלוחות"
              emptyFilterMessage="לא נמצאו שלוחות"
              itemTemplate={(option: SettingsBranches) => (
                <div>{option.branchName}</div>
              )}
              disabled={loading || branchOptions.length === 0}
              style={{ width: '100%' }}
            />
          </div>
        </div>
      </Dialog>
    );
  },
);
